import React, { useEffect, useState } from "react";
import { BsXLg } from "react-icons/bs";
import { CiAlignCenterH, CiCircleInfo } from "react-icons/ci";
import { FaDrawPolygon, FaEraser, FaSave } from "react-icons/fa";
import {
  Button,
  Card,
  CardFooter,
  CardTitle,
  Tooltip,
  UncontrolledTooltip,
} from "reactstrap";

const ModalMarkersTransform = ({
  transform,
  numSelectedPoints,
  toggle,
  clear,
  save,
  startDrawingPolygon,
  polygonsNum,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  useEffect(() => {
    setTooltipOpen(true);
    const timer = setTimeout(() => {
      setTooltipOpen(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Card
        style={{
          right: "125px",
          bottom: "95px",
          position: "absolute",
          zIndex: "1030",
          display: "block",
          overflowX: "scroll",
          width: "80px",
        }}
      >
        <CardTitle className="m-0">
          <div
            className="d-flex align-items-center p-3 gap-1"
            style={{ justifyContent: "space-between" }}
          >
            <BsXLg style={{ cursor: "pointer" }} onClick={toggle} />
            <CiCircleInfo id="info" style={{ cursor: "pointer" }} />

            <Tooltip
              placement="top"
              target="info"
              isOpen={tooltipOpen}
              toggle={() => setTooltipOpen((prev) => !prev)}
            >
              Mova pelo menos 4 pontos da origem para o destino!
            </Tooltip>
          </div>
        </CardTitle>

        <CardFooter
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <>
            <Button
              id="align-selected-markers"
              color="primary"
              disabled={numSelectedPoints < 4}
              onClick={() => transform()}
            >
              <CiAlignCenterH />
            </Button>

            <UncontrolledTooltip
              placement="left"
              target="align-selected-markers"
            >
              Alinhar Marcadores
            </UncontrolledTooltip>
          </>

          <>
            <Button
              id="draw-polygon-alignment"
              color="primary"
              disabled={polygonsNum === 1}
              onClick={() => startDrawingPolygon()}
            >
              <FaDrawPolygon />
            </Button>

            <UncontrolledTooltip
              placement="left"
              target="draw-polygon-alignment"
            >
              Selecionar Área
            </UncontrolledTooltip>
          </>

          <>
            <Button
              id="reset-points-and-clear-polygon"
              color="primary"
              onClick={() => clear()}
            >
              <FaEraser />
            </Button>

            <UncontrolledTooltip
              placement="left"
              target="reset-points-and-clear-polygon"
            >
              Limpar
            </UncontrolledTooltip>
          </>

          <>
            <Button id="save-alignment" color="success" onClick={() => save()}>
              <FaSave />
            </Button>

            <UncontrolledTooltip placement="left" target="save-alignment">
              Limpar
            </UncontrolledTooltip>
          </>
        </CardFooter>
      </Card>
    </>
  );
};

export default ModalMarkersTransform;
